import { useMemo } from 'react';

import { transformTvProgram } from '../../channel-program/transformers/transform-tv-program';
import { getNotNullableItems } from '../../../lib/get-not-nullable-items';

import { useReadChannelPlayerBaseInfo } from './use-read-channel-player-base-info';

export const useReadChannelPrograms = (contentId: string) => {
    const baseInfo = useReadChannelPlayerBaseInfo(contentId);
    return useMemo(
        () => getNotNullableItems(baseInfo?.programs).map(transformTvProgram),
        [baseInfo]
    );
};
